import loadable from '@loadable/component';
export const manifest = {
  'CpasPageHistory.Save': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasPageHistorySave";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasPageHistorySave" */
          './src/widgets/save'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/save");
            }

            return eval('require.resolve')("./src/widgets/save");
          }

        }, {
          resolveComponent: m => m.CpasPageHistorySave
        })
      }
    }
  },
  'CpasPageHistory.Link': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CpasPageHistoryLink";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CpasPageHistoryLink" */
          './src/widgets/link'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src/widgets/link");
            }

            return eval('require.resolve')("./src/widgets/link");
          }

        }, {
          resolveComponent: m => m.CpasPageHistoryLink
        })
      }
    }
  }
};